import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import './dashboard.css';

const Dashboard = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    const isAuthenticated = sessionStorage.getItem('isLoggedIn');
    if (isAuthenticated !== 'true') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    const fetchAllCounts = async () => {
      const countData = {};

      try {
        const pharmacyRes = await fetch("https://api.sgtu.ac.in/api/pharmacyForm/count/data");
        const pharmacyData = await pharmacyRes.json();
        countData["Pharmacy Data"] = pharmacyData.count || 0;
      } catch (error) {
        console.error("Error fetching Data:", error);
        countData["Pharmacy Data"] = 0;
      }

      setCounts(countData);
    };

    fetchAllCounts();
  }, []);

  const cards = Object.entries(counts).map(([title, value]) => ({
    title,
    value,
  }));

  return (
    <div className="dashboard-wrapper">
      <Sidebar isSidebarOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
      <main className="dashboard-main">
        <Header />
        <div className="dashboard-cards">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={card.title === "Pharmacy Data" ? "/pharmacyData" : "#"}
              className="card-link"
            >
              <div className="card">
                <h2>{card.title}</h2>
                <p>{card.value}</p>
              </div>
            </Link>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Dashboard;